import { render, staticRenderFns } from "./OpeningBalance.vue?vue&type=template&id=72510a18&scoped=true"
import script from "./OpeningBalance.vue?vue&type=script&lang=js"
export * from "./OpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./OpeningBalance.vue?vue&type=style&index=0&id=72510a18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72510a18",
  null
  
)

export default component.exports